import api from '@anm/api';
import { TwitchCategory } from '@anm/api/modules/stream/types';
import { STREAMING_LIVE_API_URL_PROD, STREAMING_LIVE_API_URL_TEST } from '@anm/constants/streaming';
import isDev from '@anm/helpers/is/isDev';
import useSwitchState from '@anm/hooks/useSwitchState';
import throttle from 'lodash/fp/throttle';
import { useCallback, useState, ChangeEvent } from 'react';

import { TwitchCategoryProps } from '.';

export const useTwitchCategories = ({ onCategorySelect }: TwitchCategoryProps) => {
  const [isError, setError] = useState(false);
  const [categories, setCategories] = useState<TwitchCategory[]>([]);
  const [isOpenDropdown, openDropdown, closeDropdown] = useSwitchState();

  const [categoryText, setCategoryText] = useState('');

  const handelCategoryTextChange = useCallback((e: ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;

    value && handelFetchCategories(value);

    setCategoryText(value);
    value && !isOpenDropdown && openDropdown();
  }, []);

  const baseUrl = isDev() ? STREAMING_LIVE_API_URL_TEST : STREAMING_LIVE_API_URL_PROD;

  const handelFetchCategories = throttle(500)((query: string) => {
    setError(false);

    api()
      .stream.getTwitchCategories(query, baseUrl)
      .then(setCategories)
      .catch(() => {
        setError(true);
      });
  });

  const handelSelectCategory = useCallback((category: TwitchCategory) => {
    onCategorySelect(category.id);
    setCategoryText(category.name);

    closeDropdown();
  }, []);

  return [
    categoryText,
    categories,
    isError,
    isOpenDropdown,
    handelCategoryTextChange,
    handelSelectCategory,
    openDropdown
  ] as const;
};
